'use client';

import { Skeleton } from '@mui/material';
import { HousingCardSkeleton } from '@/components';
import { Container as HomeContainer, Head, Wrapper } from '@/features/pages/home';
import { Container, ControlsBox, SkeletonGrid, StyledButton } from './styles';

export const FeaturedCarouselSkeleton = () => (
  <Wrapper>
    <HomeContainer>
      <Head>
        <Skeleton variant="text" width={280} height={40} />
        <Skeleton variant="text" width={420} height={24} />
      </Head>
      <Container>
        <ControlsBox>
          <StyledButton variant="outlined" disabled aria-label="Previous slide">
            <Skeleton variant="circular" width={16} height={16} />
          </StyledButton>
          <StyledButton variant="outlined" disabled aria-label="Next slide">
            <Skeleton variant="circular" width={16} height={16} />
          </StyledButton>
        </ControlsBox>
        <SkeletonGrid>
          {Array.from({ length: 3 }).map((_, i) => (
            <HousingCardSkeleton key={i} />
          ))}
        </SkeletonGrid>
      </Container>
    </HomeContainer>
  </Wrapper>
);
